import React, { useCallback, useState } from 'react';
import { Card, Form, Tab } from 'react-bootstrap';

import Tabs from '../../../app/components/Tabs';
import { Emails } from '../../components/Emails/Emails';
import { usePokCore } from '../../../common/hooks/usePokCore';
import { useTranslation } from '../../../translations';
import { WaitingModal } from '../../../common/components/Waiting/WaitingModal';

export const EmailsView: React.FC = () => {
  const pok = usePokCore();
  const [refresh, setRefresh] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [onlyNotSent, setOnlyNotSent] = useState<boolean>(true);

  const { t, tk } = useTranslation('applicationLng');

  const onRefresh = () => {
    setRefresh(prev => !prev);
  };

  const getData = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) =>
      pok.emails.getAllByPortion(
        t,
        tk,
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
        onlyNotSent,
        onRefresh,
        setLoading,
      ),
    [pok.emails, onlyNotSent, t, tk],
  );

  const getCount = useCallback(
    (filterText?: string, filterColumns?: string) =>
      pok.emails.getAllCount(filterText, filterColumns, onlyNotSent),
    [pok.emails, onlyNotSent],
  );

  const propertyChange = (onlyErrors: boolean) => {
    setOnlyNotSent(onlyErrors);
  };

  return (
    <>
      {loading && <WaitingModal message={t(tk.email.sendingInProgress)} />}
      <Card>
        <Tabs defaultActiveKey="search" id="emails" className="mb-3">
          <Tab eventKey="search" title={t(tk.email.emails)} className="m-3">
            <Form>
              <Form.Check
                className="mt-3"
                type="checkbox"
                defaultChecked={true}
                onChange={e => propertyChange(e.target.checked)}
                label={t(tk.email.showOnlyNotSent)}
              />
            </Form>
            <Emails getData={getData} getCount={getCount} refresh={refresh} />
          </Tab>
        </Tabs>
      </Card>
    </>
  );
};
